<script>
import baseList from "@/views/components/base/baseList.vue";
const customerId = window.localStorage.getItem("customerId");
import listRecord from "./listRecord.vue";
import dayjs from "dayjs";
export default {
  extends: baseList,
  components: { listRecord },
  data() {
    return {
      table: {
        mname: "accountingStatement",
        key: "id",
        url: {
          list: "/admin/system/sysFacilityMeterReading/summaryReport",
        },
        output: false,
        // order: "createTime",
      },
      query: {},
      actions: [
        // {
        //   label: "打印",
        //   // icon: "md-add",
        //   onClick: this.onPrint,
        //   type: "info",
        //   auth: "",
        // },
      ],
      menus: [
        {
          label: "抄张计费",
          name: "accounting_statement",
          auth: "",
        },
        {
          label: "抄张汇总",
          name: "copy_a_summary",
          auth: "",
        },
        {
          label: "纸张费率",
          name: "paperType_list",
          auth: "",
        },
      ],
      filters: [],
      tableCols: [],
      paperTypeList: [],
    };
  },
  created() {
    this.getPaperTypeList();
  },
  methods: {
    toInfo(row) {
      console.log(row);

      this.$Modal.success({
        closable: true,
        title: "抄张记录",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return <listRecord inventoryId={row.id}></listRecord>;
        },
      });
    },
    getPaperTypeList() {
      let q = {};
      $utils.api
        .load("/admin/system/paperType/options", q, "get")
        .then((res) => {
          console.log(res);
          this.paperTypeList = res.data;
          let tableCol = [
            {
              title: "序号",
              type: "index",
              width: 80,
              align: "center",
            },
            {
              title: "设备编号",
              key: "facilityCode",
              minWidth: 120,
              align: "left",
            },
            {
              title: "设备型号",
              minWidth: 150,
              align: "center",
              key: "facilityModel",
              tooltip: "true",
            },
            {
              title: "核算科室",
              key: "checkDeskName",
              minWidth: 150,
              align: "center",
              tooltip: "true",
            },
            {
              title: "计数区间",
              key: "countingPeriod",
              minWidth: 120,
              align: "left",
            },
          ];
          this.paperTypeList.forEach((item) => {
            let obj = {
              title: item.typeName,
              width: 140,
              align: "center",
              tooltip: "true",
              render: (h, params) => {
                const row = params.row;
                return row.readingDetails.map((items) => {
                  if (items.typeName == item.typeName) {
                    return <div>{items.difference}</div>;
                  }
                });
              },
            };

            tableCol.push(obj);
          });
          tableCol.push({
            title: "操作",
            align: "center",
            width: 120,
            key: "handle",
            fixed: "right",
            handle: [
              (vm, h, currentRow, param) => {
                // let directives = [];
                return (
                  <Button
                    size="small"
                    onClick={() => this.toInfo(currentRow)}
                    type="default"
                    style="border: none;color: #4991ff;margin-left: 5px;"
                  >
                    抄张记录
                  </Button>
                );
              },
            ],
          });
          this.tableCols = tableCol;
        });
    },

    onPrint() {
      //   let q = this.query;
      //   let customerNameStr =
      //     Number(customerId) === 0
      //       ? window.localStorage.getItem("customerNameClick")
      //       : window.localStorage.getItem("customerName");
      let q = this.query;
      let customerNameStr = window.localStorage.getItem("customerName");
      $utils.api
        .load(
          "/admin/system/sysFacilityMeterReading/accountingReport",
          q,
          "get"
        )
        .then((res) => {
          let list = [];
          res.rows.forEach((item, index) => {
            console.log(item);
            let obj = {
              index: index + 1,
              chargePeriod: item.chargePeriod,
              checkDeskName: item.checkDeskName,
              facilityModel: item.facilityModel,
            };
            item.readingDetails.forEach((items) => {
              obj[items.typeName] = items.amount;
            });
            obj.totalAmount = item.totalAmount;
            list.push(obj);
          });
          console.log(list);

          let properties = [
            { field: "index", displayName: "序号" },
            { field: "chargePeriod", displayName: "收费区间" },
            { field: "checkDeskName", displayName: "核算科室" },
            { field: "facilityModel", displayName: "设备型号" },
          ];

          this.paperTypeList.forEach((item) => {
            let obj2 = {
              field: item.typeName,
              displayName: item.typeName + "（元）",
            };
            properties.push(obj2);
          });
          properties.push({
            field: "totalAmount",
            displayName: "本期合计（元）",
          });
          printJS({
            printable: list,
            properties: properties,
            header: customerNameStr + "抄账核算报表",
            headerStyle: `
                      font-weight:800;
                      font-size:18px;
                      text-align: center;
                      `,
            gridHeaderStyle: "border:none;",
            gridStyle: "border:none",
            style: `
                          th{
                          font-size:14px;
                          border-bottom: 1px solid #999 !important;
                          padding: 10px 0;
                          }
                          td{
                          font-size:14px;
                          border-bottom: 1px solid #999 !important;
                          padding: 10px 0;
                          text-align:center;
                          }
                          `,
            type: "json",
          });
        });
    },
  },
};
</script>
<style scoped></style>
